import { render, staticRenderFns } from "./AppCollapseItem.vue?vue&type=template&id=b15950ac&scoped=true&"
import script from "./AppCollapseItem.vue?vue&type=script&lang=js&"
export * from "./AppCollapseItem.vue?vue&type=script&lang=js&"
import style0 from "./AppCollapseItem.vue?vue&type=style&index=0&id=b15950ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15950ac",
  null
  
)

export default component.exports